// extracted by mini-css-extract-plugin
export default {"container":"Asset_container__ud49B"};